import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded'
import { getRAGband } from '../getRAGcolor'

const ScoreTile = ({ label, consequence, likelihood, emphasize }) => {
  const total = (consequence || 0) * (likelihood || 0)
  const band = getRAGband(total)
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 110,
        p: 1.5,
        pt: 1.75,
        borderRadius: 2,
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        border: '1px solid',
        borderColor: emphasize ? `${band.color}66` : 'divider',
        bgcolor: emphasize ? `${band.color}0D` : 'transparent',
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          backgroundColor: band.color,
          opacity: emphasize ? 1 : 0.45,
        }}
      />
      <Typography
        variant="smallGrey"
        sx={{
          textTransform: 'uppercase',
          letterSpacing: '0.12em',
          fontSize: '0.68rem',
          fontWeight: 600,
        }}
      >
        {label}
      </Typography>
      <Typography
        component="div"
        sx={{
          fontWeight: 700,
          fontSize: '1.9rem',
          lineHeight: 1.2,
          color: band.color,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {total || '—'}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {total ? band.label : 'Not scored'} &middot; C{consequence || 0} &times; L
        {likelihood || 0}
      </Typography>
    </Box>
  )
}

// Initial -> Current -> Target score journey
const RiskScores = ({ risk }) => (
  <Stack
    direction="row"
    alignItems="stretch"
    gap={1}
    sx={{ '& svg': { alignSelf: 'center', color: 'text.secondary' } }}
  >
    <ScoreTile
      label="Initial"
      consequence={risk.initialRatingConsequence}
      likelihood={risk.initialRatingLikelihood}
    />
    <ArrowForwardRoundedIcon fontSize="small" aria-hidden="true" />
    <ScoreTile
      label="Current"
      consequence={risk.currentRatingConsequence || risk.initialRatingConsequence}
      likelihood={risk.currentRatingLikelihood || risk.initialRatingLikelihood}
      emphasize
    />
    <ArrowForwardRoundedIcon fontSize="small" aria-hidden="true" />
    <ScoreTile
      label="Target"
      consequence={risk.targetRatingConsequence}
      likelihood={risk.targetRatingLikelihood}
    />
  </Stack>
)

export default RiskScores
